import { Actions } from '../actions/selectClient';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IClient } from '../interfaces/client';

export type State = DeepReadonly<{
  isFetching: boolean;
  clients: IClient[] | null;
  error: AxiosError | null;
}>;

export const initialState: State = {
  isFetching: false,
  clients: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_CLIENTS_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_CLIENTS_SUCCESS':
      return {
        isFetching: false,
        clients: action.payload.sort((a, b) => a.name.localeCompare(b.name)),
        error: null
      };
    case 'FETCH_CLIENTS_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
